import { Copy } from "@msuite/ui/copy";
import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import { WorkspaceTag } from "@msuite/ui/tag";
import { formatIban, guardString } from "@msuite/utils/strings";
import { formatInvoiceAmount } from "@/components/incoming-invoices";
import { PaymentAmountCell } from "./payment-amount-cell";
import { PaymentReasonCell } from "./payment-reason-cell";
import { PaymentSupplierCell } from "./payment-supplier-cell";
import type { PaymentPreview } from "./to-payment-previews";

const columnHelper = createColumnHelper<PaymentPreview>();

/** The preview's columns: who each invoice is paid to, what is transferred, and what is in the way. */
export const columns = [
	columnHelper.accessor("number", {
		id: "number",
		header: localized("incoming_invoices.number"),
		cell: (cell) => guardString(cell.getValue()),
		size: 150,
	}),
	columnHelper.accessor("supplier", {
		id: "supplier",
		header: localized("incoming_invoices.supplier"),
		cell: (cell) => (
			<PaymentSupplierCell
				supplier={cell.getValue()}
				contactId={cell.row.original.contactId}
			/>
		),
	}),
	columnHelper.accessor("iban", {
		id: "iban",
		header: localized("incoming_invoices.iban"),
		cell: (cell) => (
			<Copy
				value={cell.getValue()}
				className="font-mono"
			>
				{formatIban(cell.getValue())}
			</Copy>
		),
		size: 240,
	}),
	columnHelper.accessor((row) => row.workspace?.name ?? null, {
		id: "workspace",
		header: localized("organization.workspace"),
		cell: (cell) => <WorkspaceTag workspace={cell.row.original.workspace ?? undefined} />,
		size: 150,
	}),
	columnHelper.accessor("skontoAmount", {
		id: "skontoAmount",
		header: localized("incoming_invoices.payments.skonto_total"),
		cell: (cell) => formatInvoiceAmount(cell.getValue(), cell.row.original.currency),
		size: 110,
	}),
	columnHelper.accessor("transferAmount", {
		id: "transferAmount",
		header: localized("incoming_invoices.payments.paid_amount"),
		cell: (cell) => <PaymentAmountCell preview={cell.row.original} />,
		size: 150,
	}),
	columnHelper.accessor("reason", {
		id: "reason",
		header: localized("general.state"),
		cell: (cell) => <PaymentReasonCell reason={cell.getValue()} />,
		size: 190,
	}),
];
